<template>
	<div>
		<h2>Estados de Cuenta</h2>
        <h2 v-if="ifin=='nop'"><strong> RENTADOS ACTUALMENTE</strong></h2>
        <h2 v-if="ifin=='sip'"><strong> FINALIZADOS </strong></h2>

        <h3> Ver solo los finalizados <input type="checkbox" id="incluyeFinalizados" v-on:click='cambioIncluye()'></h3>
        

		<br>

		<input type='text' placeholder='BUSCAR' v-model='abuscar'  >
		<br><br>

		<button class="button is-danger" name="envio"  v-on:click="enviaMails()">Enviar Estados de Cuenta a cada Inquilino por Mail </button>

		<br>
		<br>
        <div  >
    		<ul id='contratos-lista' v-if="contratosTodos !=null" align='left' >
    			<li v-for="contrat in contratosTodosBuscar" >	
    					<strong>
    						<p>Contrato # {{contrat.contrato}}</p>
                            <p>Mail registrado: {{contrat.email}}</p>

    						<p v-if="contrat.total > 0" >Saldo actual: <font color="red"> $ {{formateaNumero(contrat.total)}}</font></p>
    						<p v-if="contrat.total/contrat.importeMes > 2">
                                <font color="red"> ***** {{(contrat.total/contrat.importeMes).toFixed(0)}} meses *****
                                </font>
                            </p>
    						<p v-if="contrat.total <= 0" >Saldo actual: $ {{formateaNumero(contrat.total)}}</p>						
    						<p><font color="Olive">{{contrat.familia}}</font></p>
    						<p><font color="Olive">{{contrat.nombreComercial}}</font></p>
    						<p><font color="Olive">{{contrat.giro}}</font></p>
    						<p>{{contrat.propiedad}}</p>
    						<p>Dueño: {{contrat.dueno}}</p>
    						<p>Status: {{contrat.status}}</p>				
    						<p>Renta Mensual: $ {{formateaNumero(contrat.importeMes)}}</p>
                            <br>
                            <div @click="verContrato(contrat.contrato) ">
                                <button class="button is-primary">Ver Estado de cuenta</button>
                            </div> 

                            <div id="verEdo" v-if="verEstadoCta == true && cualContratoVer == contrat.contrato" align="center">
                                <button class= "button is-warning" @click="verEstadoCta= false" >Cerrar</button>
                                <br><br>
                                <estado-individual  :cualContrato="numContrato" :vector="vector"></estado-individual>
                                <br><br>  
                            </div>

    					</strong>
    				  	<br>
    			</li>
                              
    		</ul>

    		<span v-else><button class="button is-primary is-loading">Loading</button></span>

    		<br><br>
    			<p><strong v-if="totalSaldos"> Total Saldos hoy: $ {{formateaNumero(totalSaldos)}}</strong></p>
    			<p><strong v-if="totalSaldos"> Total Rentas Mensuales: $ {{formateaNumero(totalRentas)}}</strong></p>
    			<p><strong v-if="totalSaldos"> Total Unidades: {{formateaNumero(totalPropiedades)}}</strong></p>

    		<br><br>

        </div>

	</div>


</template>

<script>
import axios from 'axios';
import EstadoIndividual from './Contrato-estado.vue';

export default {
  name: 'Estados',
  components:{
      EstadoIndividual
  },
  mounted(){
    this.verEstadoCta= false;
  	this.getContratos();
  },
  props: ['vector'],  
  data () {
    return {
      contratosTodos: null,
      abuscar:'',
      verEstadoCta: false,
      numContrato:'',
      cualContratoVer:'',
      ifin:'nop'
    }
  },

  methods:{
  	getContratos(){
 		 // checa si tiene autorizacion
  		if(!this.vector.includes('MASTERGGUV')){
	  		if(!this.vector.includes('Contratos')){
	  			alert('Seccion no autorizada');
	  			return;
	  		}
        }

        var incluyeFinalizados2 = document.getElementById("incluyeFinalizados").checked;
        this.ifin = "nop";
        if (incluyeFinalizados2 == true) this.ifin = "sip";

        axios.get('https://www.directodo.com/Rentus/accesosdb/leeSaldos.php?ifi=' + this.ifin )
         .then((respuesta) => {
            this.contratosTodos = respuesta.data;
         });
          		

  	},
    verContrato(num){
        this.numContrato = num;
        this.verEstadoCta = true;
        this.cualContratoVer = num;
    },
  	enviaMails(){
  		if (confirm(
			"\nSe enviarán los estados de cuenta" +
			"\na cada Inquilino por Mail" + 
			"\nen este momento\n\n" + 
			"\nEsta de acuerdo ?"))

  		{
  			// continua 

		} else {
			return;
		}

	  	axios.get('https://www.directodo.com/Rentus/accesosdb/enviarEstadosDeCuentaTodos.php')
		     .then((respuesta) => {
		     	alert("\n\nMails enviados");

			 });
  	},

	vencido: function(fecha, status){

		var fecha1 = new Date(fecha); 
		fecha1.setHours(0); 

		var hoy = new Date(); 
		hoy.setHours(0);

		var fechams = fecha1.getTime(); // en milisegundos				
		var hoyms = hoy.getTime(); // en milisegundos

		if(fechams < hoyms){
			if(status == "FINALIZADO"){
				return ".";
			}
			return "Contrato Vencido";
		} else return ".";

	},

	formateaFecha: function (fecha) {
		var d = new Date(fecha); 
		if (Date.parse(d)){
			// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
			d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
			d.setHours(0);
			var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
			d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
			return d} 
		else{return "sin fecha";}
	},
	
    formateaNumero(valor1) {
        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
    },
    formateaNumeroRedondo(valor1) {
        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 0, useGrouping:true});
    },

	fechaActual(){      
	    var currentDate = new Date() //hoy
	    var day = currentDate.getDate();
	    var month = currentDate.getMonth() + 1;
	    var year = currentDate.getFullYear();
	    var my_date = year+"-"+month+"-"+day;
	    return my_date;  
	},
    cambioIncluye(){
        this.verEstadoCta= false;

        this.contratosTodos = "";
        this.getContratos(); 
    }

  },

  computed:{  	
 	contratosTodosBuscar: function (){ 
 		if(this.contratosTodos){
	  		return this.contratosTodos.filter((item) =>  
	  			   item.propiedad.toUpperCase().includes(this.abuscar.toUpperCase())  
	  			|| item.familia.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.giro.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.contrato.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.dueno.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.status.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.nombreComercial.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  		);
	  	}
  	},

    totalSaldos(){
    	if(this.contratosTodos){
            var sum = 0;
            this.contratosTodosBuscar.forEach(e => {
                sum += Number(e.total);
            });
            return sum;
        }
	},

	totalRentas(){
		if(this.contratosTodos){
            var sum = 0;
            this.contratosTodosBuscar.forEach(e => {
                sum += Number(e.importeMes);
            });
            return sum;
        }
	},

	totalPropiedades(){
		if(this.contratosTodos){
            var sum = 0;
            this.contratosTodosBuscar.forEach(e => {
                sum = sum + 1;
            });
            return sum;
        }
	}

  }


}

</script>

<style lang="scss">
	#contratos-lista{
		padding:20px;
		li{
			width:100%;
			height: 100%;
			background: #eee;
			overflow: hidden;
			text-align: left;
		}
	}
</style>


// WEBPACK FOOTER //
// src/Estados-de-cuenta.vue